import Label from "@marginly/ui/components/label";
import { cssVar } from "@marginly/ui/util/style";
import styled, { css } from "styled-components";

import { TokenIcon as TokenIconUnstyled } from "@/components/common/token";

export const TokenIcon = styled(TokenIconUnstyled)`
  path {
    fill: var(--icon-primary);
  }
`;

export const TVLBar = styled.div`
  position: relative;
  border-radius: var(--rounding-radius-xxs, 4px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  height: 8px;
  overflow: hidden;
  .filled {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    border-radius: var(--rounding-radius-xxs, 4px);
    background: var(--fill-accent-primary, #9fe);
    width: 62px;
  }
`;

const badgeStyles = css`
  position: absolute;
  right: 12px;
  top: 12px;
`;

export const Badge = styled(Label)`
  ${badgeStyles}
`;

export const PositionBadge = styled(Label)`
  ${badgeStyles}
  background: var(--fill-negative-bg);
  color: var(--text-negative);
  &.up {
    background: var(--fill-positive-bg);
    color: var(--text-positive);
  }
`;
